<div>
  <gk-dynamic-navbar [navbarConfig]="currentNavbarConfig"></gk-dynamic-navbar>
</div>
